import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import { TotalEarningTitle } from '../../../../Utils/Constants'
import { P } from '../../../../AbstractElements'
import ReactApexChart from 'react-apexcharts'
import { goalOverviewChart } from '../../../../Data/DashboardsData/DefaultData'

export default function GoalOverviewSec() {
    return (
        <Col xl={3} md={6} className="box-col-6">
            <Card className="goal-overview-sec">
                <DropdownWithHeader headerClass='pb-0' heading={TotalEarningTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    <div className="goal-chart-block">
                        <div id="goal-overview-chart">
                            <ReactApexChart type='radialBar' options={goalOverviewChart} series={goalOverviewChart.series} height={390} />
                        </div>
                        <div className="highest-goal">
                            <span>$3.9k</span>
                            <P>Highest</P>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}
